// src/components/billing/CancelSurveyModal.js — Stripe-style cancellation
// survey. A reason is required to confirm; the comment is optional.
import React, { useState } from 'react';

export const CANCEL_REASONS = [
    { value: 'too_expensive', label: 'Too expensive' },
    { value: 'missing_features', label: 'Missing features' },
    { value: 'switched_service', label: 'Switched to another service' },
    { value: 'unused', label: 'No longer need it' },
    { value: 'customer_service', label: 'Customer service' },
    { value: 'too_complex', label: 'Too complicated' },
    { value: 'low_quality', label: 'Quality was less than expected' },
    { value: 'other', label: 'Other' },
];

const CancelSurveyModal = ({ premiumUntilLabel, busy, onConfirm, onClose }) => {
    const [reason, setReason] = useState('');
    const [comment, setComment] = useState('');

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => !busy && onClose()} />
            <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#0b0e14] p-6 shadow-2xl max-h-[90vh] overflow-y-auto">
                <h3 className="text-lg font-semibold text-white">Cancel Premium?</h3>
                <p className="text-sm text-neutral-400 mt-1.5">
                    You'll keep Premium until <span className="text-white font-medium">{premiumUntilLabel}</span>, then your plan reverts to Free. You can resume anytime before then.
                </p>
                <fieldset className="mt-5">
                    <legend className="text-sm font-medium text-neutral-200 mb-2">Why are you canceling?</legend>
                    <div className="space-y-1.5">
                        {CANCEL_REASONS.map(({ value, label }) => (
                            <label key={value}
                                className={`flex items-center gap-3 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${reason === value ? 'border-cyan-500/60 bg-cyan-500/10 text-white' : 'border-white/10 bg-white/[0.03] text-neutral-300 hover:bg-white/5'}`}>
                                <input type="radio" name="cancel-reason" value={value}
                                    checked={reason === value} onChange={() => setReason(value)}
                                    className="accent-cyan-500" />
                                {label}
                            </label>
                        ))}
                    </div>
                </fieldset>
                <textarea value={comment} onChange={(e) => setComment(e.target.value)}
                    maxLength={2000} rows={3}
                    placeholder="Anything else you'd like to share? (optional)"
                    className="mt-4 w-full bg-black/30 border border-white/10 text-white rounded-lg px-3 py-2 text-sm placeholder-neutral-600 focus:outline-none focus:ring-2 focus:ring-cyan-500/60" />
                <div className="flex justify-end gap-2 mt-5">
                    <button onClick={onClose} disabled={busy}
                        className="px-4 py-2 text-sm font-medium text-neutral-300 hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg transition-colors">
                        Keep Premium
                    </button>
                    <button onClick={() => onConfirm(reason, comment.trim())} disabled={busy || !reason}
                        className="px-4 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-500 rounded-lg disabled:opacity-50 transition-colors">
                        {busy ? 'Cancelling…' : 'Confirm cancellation'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelSurveyModal;
